export enum SourceSystem {
  Sgc,
  Adebs,
  Both
}
